import Header from '@/components/Header';
import { LayoutDetector } from '@/components/LayoutDetector';
import { useIsDesktopLayout } from '@/components/LayoutDetector/hooks';
import LiveChannelsBar from '@/components/LiveChannelsBar';
import PageWrapper from '@/components/Main/PageWrapper';
import PubNubWrapper from '@/components/PubNubWrapper';

import CommunityFeedCard from './CommunityFeedCard';
import HomeContent from './HomeContent';
import UpcomingEventsCard from './UpcomingEventsCard';

const Home = () => {
  const isDesktop = useIsDesktopLayout();
  return (
    <div className="relative grid h-full grid-cols-1 overflow-x-hidden fullscreen:block mobile:w-full desktop:grid-cols-[64px_2fr_minmax(340px,1fr)]">
      <aside className="preflight relative z-[11] h-full border-r fullscreen:hidden mobile:hidden">
        {/* We keep the wrapper exists to keep virtual DOM structure as much as possible */}
        {isDesktop && (
          <PubNubWrapper>
            <LiveChannelsBar />
          </PubNubWrapper>
        )}
      </aside>
      <main className="h-full overflow-y-auto">
        <HomeContent />
      </main>
      <aside className="preflight grid h-full grid-rows-[repeat(2,minmax(300px,1fr))] gap-3 overflow-y-auto border-l p-3 shadow-md fullscreen:hidden mobile:hidden">
        {/* We keep the wrapper exists to keep virtual DOM structure as much as possible */}
        {isDesktop && (
          <>
            <UpcomingEventsCard />
            <CommunityFeedCard />
          </>
        )}
      </aside>
    </div>
  );
};

const HomeWithLayout = () => {
  return (
    <LayoutDetector
      title="Home"
      breakPoint={1023} // keep it as stable as possible in mobile device to prevent layout change when orientation changes
      desktop={
        <>
          <Header />
          <PageWrapper>
            <Home />
          </PageWrapper>
        </>
      }
      mobile={<Home />}
    />
  );
};

export default HomeWithLayout;
